module.exports = __webpack_public_path__ + "img/mapa.99a71ff8.png";